import { Component, EventEmitter, Output } from '@angular/core';
import { ISidebarItem } from '../../../../nvps-libraries/design/nv-sidebar-list/nv-sidebar.interface';

@Component({
  selector: 'shelter-network-settings-right-nav',
  template: require('./shelter-network-settings-right-nav.component.html'),
  styles: [require('./shelter-network-settings-right-nav.component.scss')],
})
export class ShelterNetworkSettingsRightNavComponent {
  @Output() clickedAddUser = new EventEmitter();

  title = 'Tools';
  sidebarItems: ISidebarItem[] = [
    {
      human: 'Add user',
      key: 'addUser',
      icon: 'person-add',
    },
  ];

  onSelectItem($selectedKey: string): void {
    switch ($selectedKey) {
      case 'addUser':
        this.clickedAddUser.emit();
        break;
      default:
        break;
    }
  }
}
